import { Toggle } from '@atrvd/saas-ui'

interface FacilityStatusToggleProps {
  facilityName: string
  /**
   * The facility's Sage location id: names are not unique, the id is, so it
   * tells same-named facilities' switches apart. Null when the facility has none.
   */
  sageLocationId: string | null
  /** The stored `is_active`. */
  active: boolean
  /** A status write for this facility is in flight. */
  busy: boolean
  onChange: (active: boolean) => void
}

/**
 * The Status cell of the Settings → Facilities table: switches a facility
 * active or inactive in place, without opening the Edit dialog.
 */
export function FacilityStatusToggle({
  facilityName,
  sageLocationId,
  active,
  busy,
  onChange,
}: FacilityStatusToggleProps) {
  return (
    <span className="inline-flex items-center gap-2">
      <Toggle
        checked={active}
        disabled={busy}
        size="sm"
        aria-label={sageLocationId ? `${facilityName} (${sageLocationId}) active` : `${facilityName} active`}
        onChange={onChange}
      />
      {/* The switch already tells assistive tech its state; this text is for sighted users. */}
      <span aria-hidden="true" className="text-sm text-muted-foreground">
        {active ? 'Active' : 'Inactive'}
      </span>
    </span>
  )
}
